<template>
  <yxt-drawer
    :title="title"
    :visible.sync='drawerVisible'
    class='yxtbiz-labelling'
    destroy-on-close
    size='960px'
    :before-close="beforeClose"
  >
    <div
      v-if='drawerVisible'
      v-loading='loading'
      class='labelling'
    >
      <div class='mr32 flex-1 overflow-x-hidden flex flex-col'>
        <div class='labelling__filter'>
          <div class='labelling__filter-search'>
            <yxt-select
              v-model='tagType'
              :placeholder="$t('pc_biz_labelling_classify'/*标签分类*/)"
              size='small'
              style='width: 100%;'
            >
              <yxt-option
                :label="$t('pc_biz_labelling_lbl_normal')"
                :value='0'
              />
              <yxt-option
                :label="$t('pc_biz_labelling_lbl_layered')"
                :value='1'
              />
            </yxt-select>
          </div>
          <div class='labelling__filter-select'>
            <yxt-select
              v-model='currentCatalog'
              clearable
              :placeholder="$t('pc_biz_labelling_classify')"
              size='small'
              style='width: 100%;'
              @change='catalogChange'
            >
              <yxt-option
                v-for='item in catalog'
                :key='item.id'
                :label='item.catalogName'
                :value='item.id'
              />
            </yxt-select>
          </div>
          <div class='ml12'>
            <yxt-input
              v-model='params.keyWord'
              style='width: 240px;'
              :placeholder="$t('pc_biz_labelling_input_tip')"
              clearable
              searchable
              @search="getLabellingTagList"
              @clear="getLabellingTagList"
              size='small'
            />
          </div>
        </div>
        <yxt-scrollbar :fit-height='true'>
          <div
            class='labelling__list'
          >
            <div
              v-show='tagType===0'
              class='labelling__list__normal'
            >
              <yxt-empty v-if='normalTags.length === 0 && !loading' />
              <selectable-tag
                v-for='tag in normalTags'
                v-else
                :key='tag.tagId'
                :selected='tag.selected'
                @click.native='handelTagSelected(tag)'
              >
                <yxt-tooltip
                  effect='dark'
                  open-filter
                  :content='tag.tagName'
                  placement='top'
                >
                  <span class='ellipsis'>{{ tag.tagName }}</span>
                </yxt-tooltip>
              </selectable-tag>
            </div>
            <div
              v-show='tagType===1'
              class='labelling__list__layered'
            >
              <yxt-empty v-if='layeredTags.length === 0 && !loading' />
              <div
                v-for='tag in layeredTags'
                v-else
                :key='tag.tagId'
                class='layered__group'
              >
                <div class='layered__group-name'>
                  {{ tag.tagName }}<span>（{{ tag.valueChooseModel ? $t('pc_biz_labelling_input_multi') : $t('pc_biz_labelling_input_single') }}）</span>
                </div>
                <div class='layered__group-tags'>
                  <selectable-tag
                    v-for='tagOption in tag.tagValueBeanList'
                    :key='tagOption.tagValueId'
                    :selected='tagOption.selected'
                    @click.native='handelLayeredTagSelected(tagOption, tag)'
                  >
                    <yxt-tooltip
                      effect='dark'
                      open-filter
                      :content='tagOption.tagValueName'
                      placement='top'
                    >
                      <span class='ellipsis'>{{ tagOption.tagValueName }}</span>
                    </yxt-tooltip>
                  </selectable-tag>
                </div>
              </div>
            </div>
          </div>
        </yxt-scrollbar>
      </div>
      <div class='flex-shrink-0 border-left labelling__selected'>
        <div class='labelling__selected-title'>
          <div class='font-medium'>
            {{ $t('pc_biz_labelling_selected') }}{{ totalCount }}
          </div>
          <yxt-button
            type='text'
            @click='clearAll'
          >
            {{ $t('pc_biz_labelling_clearall') }}
          </yxt-button>
        </div>
        <div class='mt16 overflow-hidden'>
          <yxt-scrollbar :fit-height='true'>
            <div v-if='layeredTagsComputed && layeredTagsComputed.length'>
              <div class='color-gray-9 mb8'>
                {{ $t('pc_biz_labelling_lbl_layered') }}
              </div>
              <div class='clearfix pb16'>
                <template v-for='layeredTag in layeredTagsComputed'>
                  <template v-for='tagValue in layeredTag.tagValueList'>
                    <yxt-tooltip
                      :key='layeredTag.tagId + tagValue.tagValueId'
                      class='item'
                      effect='dark'
                      :content="layeredTag.tagName + '：' + tagValue.tagValueName"
                      placement='top'
                    >
                      <yxt-tag
                        class='mr8 overflow-hidden mb8 standard-size-12 labelling__selected-tag clearfix'
                        type='info'
                        size='mini'
                        closable
                        @close='handleCloseTag(layeredTag, tagValue, 1)'
                      >
                        <span class='ellipsis'>{{ layeredTag.tagName }}：{{ tagValue.tagValueName }}</span>
                      </yxt-tag>
                    </yxt-tooltip>
                  </template>
                </template>
              </div>
            </div>
            <div v-if='normalSelectedTags && normalSelectedTags.length'>
              <div class='color-gray-9 mb8'>
                {{ $t('pc_biz_labelling_lbl_normal') }}
              </div>
              <div class='clearfix pb16'>
                <template v-for='normalTag in normalSelectedTags'>
                  <yxt-tooltip
                    :key='normalTag.tagId'
                    class='item'
                    effect='dark'
                    :content='normalTag.tagName'
                    placement='top'
                  >
                    <yxt-tag
                      class='mr8 overflow-hidden mb8 standard-size-12 labelling__selected-tag clearfix'
                      type='info'
                      size='mini'
                      closable
                      @close='handleCloseTag(normalTag, null, 0)'
                    >
                      <span class='ellipsis'>{{ normalTag.tagName }}</span>
                    </yxt-tag>
                  </yxt-tooltip>
                </template>
              </div>
            </div>
          </yxt-scrollbar>
        </div>
      </div>
    </div>
    <div slot='footer'>
      <yxt-button
        plain
        @click='cancel'
      >
        {{ $t('pc_biz_labelling_cancel'/*取消*/) }}
      </yxt-button>
      <yxt-button
        :loading='submitLoading'
        type='primary'
        @click='submit'
      >
        {{ $t('pc_biz_labelling_confirm'/*确定*/) }}
      </yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
import { getLabellingList, getTagCatalogList } from './service';
import SelectableTag from './selectableTag';

export default {
  name: 'YxtbizLabelling',
  components: {
    SelectableTag
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dimensionId: String,
    defaultSelectedTags: {
      default: () => {
        return [];
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: true,
      drawerVisible: false,
      params: {
        catalogId: '',
        keyWord: '',
        tagEnable: 1,
        updateType: 0
      },
      catalog: [],
      currentCatalog: '',
      tagType: 0, // 标签类型 0：普通标签；1：分层标签
      normalTags: [], // 普通标签
      layeredTags: [], // 分层标签
      normalSelectedTags: [],
      layeredSelectedTags: [],
      deleteSingleTags: []
    };
  },

  computed: {
    // 选中的分层标签
    layeredTagsComputed() {
      let layeredTags = this.layeredSelectedTags.map(item => ({
        ...item,
        tagValueList: item.tagValueBeanList.filter(tag => tag.selected)
      }));
      layeredTags = layeredTags.filter(item => item.tagValueList && item.tagValueList.length);
      return layeredTags;
    },
    totalCount() {
      const normalLength = this.normalSelectedTags.length;
      let layeredLength = 0;
      this.layeredTagsComputed.forEach(tag => {
        layeredLength += tag.tagValueList ? tag.tagValueList.length : 0;
      });
      return normalLength + layeredLength;
    }
  },

  watch: {
    visible(value) {
      this.drawerVisible = value;
      if (value) {
        this.reset();
        this.search();
      }
    },
    drawerVisible(value) {
      if (!value) this.$emit('update:visible', false);
    },
    defaultSelectedTags() {
      this.setSelectedTags();
    }
  },
  destroyed() {
    // 防止热更新后没有改变visible的值
    this.$emit('update:visible', false);
  },

  mounted() {
  },

  created() {
  },

  methods: {
    reset() {
      this.tagType = 0;
      this.list = [];
      this.catalog = [];
      this.currentCatalog = '';
      this.normalSelectedTags = [];
      this.layeredSelectedTags = [];
      this.normalTags = [];
      this.layeredTags = [];
      this.deleteSingleTags = [];
      this.params = {
        catalogId: '',
        keyWord: '',
        tagEnable: 1,
        updateType: 0
      };
    },
    search() {
      this.params.dimensionId = this.dimensionId;
      this.getLabellingTagList();
      this.getCatalogList();
    },
    catalogChange(value) {
      this.params.catalogId = value;
      this.getLabellingTagList();
    },
    async getLabellingTagList() {
      this.loading = true;
      if (this.params.keyWord && this.params.keyWord.trim) {
        this.params.keyWord = this.params.keyWord.trim();
      }
      getLabellingList(this.params).then(result => {
        this.normalTags = result.datas.filter(item => item.type === 0).map(item => ({ ...item, selected: false }));
        this.layeredTags = result.datas.filter(item => item.type === 1).map(item => {
          item.tagValueBeanList.forEach(value => {
            value.selected = false;
          });
          return item;
        });
        this.setSelectedTags();
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        console.error(err);
      });
    },
    // 根据选中数据设置选中状态
    setSelectedTags() {
      const normalTags = this.normalTags.filter(item => this.defaultSelectedTags.some(t => t.tagId === item.tagId)).map(item => ({
        ...item,
        selected: true
      }));
      const layeredTags = this.layeredTags.filter(item => this.defaultSelectedTags.some(t => t.tagId === item.tagId));
      layeredTags.forEach(item => {
        const selectedData = this.defaultSelectedTags.find(data => data.tagId === item.tagId);
        item.tagValueBeanList.forEach(tag => {
          tag.selected = selectedData.tagValueBeans.some(v => v.tagValueId === tag.tagValueId);
        });
      });
      normalTags.forEach(tag => {
        const find = this.normalSelectedTags.find(selected => selected.tagId === tag.tagId);
        if (!find) {
          this.normalSelectedTags.push(tag);
        }
      });
      layeredTags.forEach(tag => {
        const find = this.layeredSelectedTags.find(selected => selected.tagId === tag.tagId);
        if (!find) {
          this.layeredSelectedTags.push(tag);
        } else {
          tag.tagValueBeanList.forEach(bean => {
            const findChild = find.tagValueBeanList.find(child => child.tagValueId === bean.tagValueId && child.selected && !bean.selected);
            if (findChild) {
              findChild.selected = true;
            };
          });
        }
      });
      this.normalSelectedTags.forEach(item => {
        const index = this.normalTags.findIndex(d => d.tagId === item.tagId);
        if (index > -1) {
          this.normalTags[index] = item;
        }
      });
      this.layeredSelectedTags.forEach(item => {
        const index = this.layeredTags.findIndex(d => d.tagId === item.tagId);
        if (index > -1) {
          this.layeredTags[index] = item;
        }
      });
    },
    getCatalogList() {
      getTagCatalogList().then(result => {
        this.catalog = result;
      }).catch(error => {
        console.error(error);
      });
    },
    handelTagSelected(tag) {
      tag.selected = !tag.selected;
      if (tag.selected) {
        this.normalSelectedTags.push(tag);
      } else {
        this.normalSelectedTags = this.normalSelectedTags.filter(d => d.tagId !== tag.tagId);
      }
      this.getNormalDeleteTags(tag);
    },
    handelLayeredTagSelected(option, tag) {
      if (tag.valueChooseModel) { // 多选
        option.selected = !option.selected;
      } else { // 单选
        tag.tagValueBeanList.filter(item => item.tagValueId !== option.tagValueId).forEach(item => {
          item.selected = false;
        });
        option.selected = !option.selected;
      }
      // this.layeredSelectedTags
      if (tag.tagValueBeanList.some(item => item.selected)) {
        const currentSelectedTagIndex = this.layeredSelectedTags.findIndex(item => item.tagId === tag.tagId);
        if (currentSelectedTagIndex > -1) {
          this.layeredSelectedTags[currentSelectedTagIndex] = tag;
        } else {
          this.layeredSelectedTags.push(tag);
        }
      } else {
        this.layeredSelectedTags = this.layeredSelectedTags.filter(item => item.tagId !== tag.tagId);
      }
      this.getLayeredDeleteTags(option, tag);
    },
    cancel() {
      this.drawerVisible = false;
    },
    getNormalDeleteTags(tag) {
      const singleTag = this.defaultSelectedTags.find(item => item.tagId === tag.tagId);
      if (!singleTag) return;
      const index = this.deleteSingleTags.findIndex(item => item.tagId === tag.tagId);
      if (tag.selected) {
        if (index > -1) {
          this.deleteSingleTags = this.deleteSingleTags.filter(item => item.tagId !== tag.tagId);
        }
      } else {
        this.deleteSingleTags.push({
          tagId: tag.tagId,
          tagValueIdList: tag.tagValueBeanList.map(item => item.tagValueId)
        });
      }
    },
    getLayeredDeleteTags(option, tag) {
      const layeredTag = this.defaultSelectedTags.find(item => item.tagId === tag.tagId);
      if (!layeredTag) return;
      const index = this.deleteSingleTags.findIndex(item => item.tagId === tag.tagId);
      if (option.selected) {
        if (index > -1) {
          this.deleteSingleTags[index].tagValueIdList = this.deleteSingleTags[index].tagValueIdList.filter(item => item !== option.tagValueId);
          if (this.deleteSingleTags[index].tagValueIdList.length === 0) {
            this.deleteSingleTags = this.deleteSingleTags.filter(item => item.tagId === tag.tagId);
          }
        }
      } else {
        if (index === -1) {
          this.deleteSingleTags.push({
            tagId: tag.tagId,
            tagValueIdList: [option.tagValueId]
          });
        } else {
          this.deleteSingleTags[index].tagValueIdList.push(option.tagValueId);
        }
      }
    },
    // 已选择tag中删除tag, tagType: 1 分层标签 0 普通标签
    handleCloseTag(layeredTag, tagValue, tagType) {
      if (tagType === 1 && !tagValue.selected) {
        return;
      }
      if (tagType === 0 && !layeredTag.selected) {
        return;
      }
      if (tagType === 1) {
        this.handelLayeredTagSelected(tagValue, layeredTag);
      } else {
        // 普通标签
        this.handelTagSelected(layeredTag);
      }
    },
    clearAll() {
      this.normalSelectedTags.forEach(tag => {
        tag.selected = false;
      });
      this.layeredSelectedTags.forEach(tag => {
        tag.tagValueBeanList.forEach(subTag => {
          subTag.selected = false;
        });
      });
      this.deleteSingleTags = this.defaultSelectedTags.map(tag => {
        return {
          tagId: tag.tagId,
          tagValueIdList: tag.tagValueBeans.map(value => value.tagValueId)
        };
      });
      this.normalSelectedTags = [];
      this.layeredSelectedTags = [];
    },
    getPostData() {
      const normalTagList = this.normalSelectedTags.map(item => ({
        tagId: item.tagId,
        tagValueIdList: item.tagValueBeanList.map(tag => tag.tagValueId)
      }));
      const layeredTags = this.layeredTagsComputed.map(item => ({
        tagId: item.tagId,
        tagValueIdList: item.tagValueList.map(selected => selected.tagValueId)
      }));
      return [...normalTagList, ...layeredTags];
    },
    submit() {
      this.$emit('submit', this.getPostData(), this.deleteSingleTags);
    },
    beforeClose(done) {
      let postIds = [];
      this.normalSelectedTags.forEach(item => {
        postIds.push(item.tagId);
        item.tagValueBeanList.forEach(tag => {
          postIds.push(tag.tagValueId);
        });
      });
      this.layeredTagsComputed.forEach(item => {
        postIds.push(item.tagId);
        item.tagValueList.forEach(tag => {
          postIds.push(tag.tagValueId);
        });
      });
      let defaultIds = [];
      this.defaultSelectedTags.forEach(tag => {
        defaultIds.push(tag.tagId);
        tag.tagValueBeans && tag.tagValueBeans.forEach(value => {
          defaultIds.push(value.tagValueId);
        });
      });
      postIds.sort();
      defaultIds.sort();
      if (postIds.length !== defaultIds.length) {
        done(true);
        return;
      }
      for (let i = 0; i < postIds.length; i++) {
        if (postIds[i] !== defaultIds[i]) {
          done(true);
          break;
        }
      }
      done(false);
    }
  }
};
</script>
<style lang='scss'>
</style>
